<template>
  <div
    class="rounded-full flex items-center justify-center border-2 w-40 h-40 relative flex-shrink-0 contributor-badge-cw bg-white"
  >
    <div
      class="bg-no-repeat bg-cover bg-center w-36 h-36 rounded-full"
      :style="{ backgroundImage: `url(${path})` }"
    />

    <div
      class="absolute border-4 border-white cw-gradient -top-1.5 right-0 h-10 w-10 rounded-full text-white"
    >
      <div class="flex items-center justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Logo',

  props: {
    path: {
      type: String,
      required: true,
    },
  },
})
</script>

<style scoped>
.contributor-badge-cw::before {
  border-radius: 100%;
  border: 10px solid transparent;
}
</style>
